// src/core/store/registerMarketerSlice.ts

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface MarketerData {
    fullName: string;
    lastName: string;
    nationalCode: string;
    birthDate: string;
    gender: string;
    province: string;
    city: string;
    address: string;
    postalCode: string;
    townshipId?: number | null;
}

interface RegisterMarketerState {
    selectedRole: "marketer" | null;
    marketerData: MarketerData;
    isComplete: boolean;
}

const initialState: RegisterMarketerState = {
    selectedRole: "marketer",
    marketerData: {
        fullName: "",
        lastName: "",
        nationalCode: "",
        birthDate: "",
        gender: "",
        province: "",
        city: "",
        address: "",
        postalCode: "",
        townshipId: null,
    },
    isComplete: false,
};

const registerMarketerSlice = createSlice({
    name: 'registerMarketer',
    initialState,
    reducers: {
        // تنظیم نقش
        setMarketerRole: (state, action: PayloadAction<"marketer">) => {
            state.selectedRole = action.payload;
        },

        // به‌روزرسانی اطلاعات بازاریاب
        updateMarketerData: (state, action: PayloadAction<Partial<MarketerData>>) => {
            state.marketerData = {
                ...state.marketerData,
                ...action.payload,
            };
        },

        // تنظیم کامل اطلاعات بازاریاب
        setMarketerData: (state, action: PayloadAction<any>) => {
            state.marketerData = action.payload;
        },

        // تکمیل ثبت‌نام
        completeMarketerRegister: (state) => {
            state.isComplete = true;
        },

        // ریست کامل ثبت‌نام
        resetMarketerRegister: () => initialState,
    },
});

export const {
    setMarketerRole,
    updateMarketerData,
    setMarketerData,
    completeMarketerRegister,
    resetMarketerRegister,
} = registerMarketerSlice.actions;

export default registerMarketerSlice.reducer;